import { t } from 'i18next';
import * as Yup from 'yup';

type Condition = {
    operator: string;
    parameter: string;
    /** Converted to an Array during the Mutation */
    values: string;
    readonly: boolean;
};

type Conditions = Condition[];

export type RuleGroupConditionsSchema = {
    /** ID created in the backend. */
    id?: number;
    name: string;
    executionOrder: number;
    enabled: boolean;
    conditions: Conditions;
};

export const ruleGroupConditionsSchema = Yup.object({
    name: Yup.string()
        .min(1, () => t('minLength', { field: t('ruleGroupConditions.form.name.label'), charCount: 1 }))
        .max(150, () => t('maxLength', { field: t('ruleGroupConditions.form.name.label'), charCount: 150 }))
        .trim(() => t('validation.noLeadingTrailingSpaces'))
        .strict()
        .required(() => t('validation.required', { field: t('ruleGroupConditions.form.name.label') })),
    executionOrder: Yup.number()
        .positive(() => t('validation.positive', { field: t('ruleGroupConditions.form.executionOrder.label') }))
        .integer()
        .required(() => t('validation.required', { field: t('ruleGroupConditions.form.executionOrder.label') })),
    enabled: Yup.boolean().default(true).required(),
    conditions: Yup.array().of(
        Yup.object({
            operator: Yup.string().required(),
            parameter: Yup.string().required(),
            values: Yup.string()
                .trim(() => t('validation.noLeadingTrailingSpaces'))
                .strict()
                .required(() => t('validation.required', { field: t('ruleGroupConditions.form.values.label') })),
            readonly: Yup.boolean().default(false).required()
        })
    )
});
